import Router from './js/util/Router';
import common from './js/routes/common';
import home from './js/routes/home';
import about from './js/routes/about';
import singleProgetto from './js/routes/singleProgetto';

import './scss/application.scss';

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
	/** All pages */
	common,
	/** Home page */
	home,
	/** About page */
	about,
	/** Single Progetto page */
	singleProgetto,
});

/** Load Events */
jQuery(document).ready(() => {
	routes.loadEvents()
});
